import React, { useState, useEffect } from 'react';

function Quiz({ category, onQuizComplete }) {
  const [questions, setQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [score, setScore] = useState(0);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [ setShowResult] = useState(false);

  useEffect(() => {
    // Load questions based on category
    import(`../data/${category}.json`)
      .then(data => {
        setQuestions(data.default || data);
      })
      .catch(err => console.error('Error loading questions:', err));
  }, [category]);

  const handleAnswerClick = (index) => {
    if (selectedAnswer !== null) return; // Prevent multiple clicks

    setSelectedAnswer(index);
    setShowResult(true);

    const isCorrect = index === questions[currentQuestion].correct;
    if (isCorrect) {
      setScore(score + 1);
    }

    // Move to next question after 1.5 seconds
    setTimeout(() => {
      if (currentQuestion + 1 < questions.length) {
        setCurrentQuestion(currentQuestion + 1);
        setSelectedAnswer(null);
        setShowResult(false);
      } else {
        onQuizComplete(score + (isCorrect ? 1 : 0), questions.length);
      }
    }, 1500);
  };

  const getOptionClass = (index) => {
    if (selectedAnswer === null) return '';
    if (index === questions[currentQuestion].correct) return 'correct';
    if (index === selectedAnswer) return 'incorrect';
    return '';
  };

  if (questions.length === 0) {
    return (
      <div className="quiz-container">
        <p style={{ textAlign: 'center', fontSize: '1.5em' }}>Loading questions...</p>
      </div>
    );
  }

  return (
    <div className="quiz-container">
      <div className="quiz-header">
        <div className="quiz-category">
          {category.charAt(0).toUpperCase() + category.slice(1)}
        </div>
        <div className="quiz-progress">
          {currentQuestion + 1} / {questions.length}
        </div>
      </div>

      <div className="question-text">
        {questions[currentQuestion].question}
      </div>

      <div className="options-grid">
        {questions[currentQuestion].options.map((option, index) => (
          <button
            key={index}
            className={`option-btn ${getOptionClass(index)}`}
            onClick={() => handleAnswerClick(index)}
            disabled={selectedAnswer !== null}
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
}

export default Quiz;
